// Mirrors AppFeature.cs on the backend
export const AppFeature = {
  // Personnel
  Employee: 'Employee',
  Employment: 'Employment',
  PayrollDeduction: 'PayrollDeduction',
  // Reference data
  EmploymentType: 'EmploymentType',
  EmploymentStatus: 'EmploymentStatus',
  CessationType: 'CessationType',
  MoMoOperator: 'MoMoOperator',
  // Estates
  Estate: 'Estate',
  Block: 'Block',
  Operation: 'Operation',
  OperationRate: 'OperationRate',
  AverageWeight: 'AverageWeight',
  // Payroll
  PayrollCycle: 'PayrollCycle',
  PayrollTask: 'PayrollTask',
  // Expenses
  Vendor: 'Vendor',
  OperationalExpense: 'OperationalExpense',
  // Inventory
  Inventory: 'Inventory',
  ItemCategory: 'ItemCategory',
  Store: 'Store',
  Requisition: 'Requisition',
  // Deductions (types/config)
  Deductions: 'Deductions',
  // Salary grid & placement
  SalaryGrid: 'SalaryGrid',
  SalaryPlacement: 'SalaryPlacement',
  // Allowances
  AllowanceType: 'AllowanceType',
  Allowance: 'Allowance',
  // Statutory rates
  StatutoryRates: 'StatutoryRates',
  // Working Year
  WorkingYear: 'WorkingYear',
  // Sales
  SaleOrder: 'SaleOrder',
  Sku: 'Sku',
  BottlingBatch: 'BottlingBatch',
  CartonningBatch: 'CartonningBatch',
  OilPurchase: 'OilPurchase',
  SaleType: 'SaleType',
  PricingTier: 'PricingTier',
  SalePrice: 'SalePrice',
  MarketPrice: 'MarketPrice',
  Customer: 'Customer',
  // Reporting
  Report: 'Report',
  SalesReport: 'SalesReport',
  // System
  SystemLog: 'SystemLog',
  SystemSettings: 'SystemSettings',
  User: 'User',
  Role: 'Role',
} as const;

export type AppFeatureValue = (typeof AppFeature)[keyof typeof AppFeature];

// Mirrors AppAction.cs on the backend
export const AppAction = {
  Create: 'Create',
  Read: 'Read',
  Update: 'Update',
  Delete: 'Delete',
  Submit: 'Submit',
  Draft: 'Draft',
  Validate: 'Validate',
  Approve: 'Approve',
  Reject: 'Reject',
  Activate: 'Activate',
  Suspend: 'Suspend',
  Reinstate: 'Reinstate',
  Cease: 'Cease',
  ChangeFunction: 'ChangeFunction',
  Receive: 'Receive',
  Transfer: 'Transfer',
  Issue: 'Issue',
  RecordPayment: 'RecordPayment',
} as const;

export type AppActionValue = (typeof AppAction)[keyof typeof AppAction];

// Mirrors the backend permission ID format: "Permission.{Feature}.{Action}" (e.g. "Permission.Estate.Create")
export type PermissionName = `Permission.${AppFeatureValue}.${AppActionValue}`;

export function permissionFor(feature: AppFeatureValue, action: AppActionValue): PermissionName {
  return `Permission.${feature}.${action}`;
}
